<template>
    <div :class="'d-flex align-items-center ' + pdClass">
        <font-awesome-icon :icon="['fas', 'bell']" />
        <span class="indicator" v-if="hasNotifications"></span>
    </div>
</template>

<script>
import { useUserStore } from '@/store/user';
export default {
    name:"AppNotification",
    setup() {
        const userStore = useUserStore();

        return  { userStore }
    },
    mounted() {
        let user = this.userStore.getUser;
        if (user) {
            if (user.unreadNotifications) {
                if (user.unreadNotifications > 0) {
                    this.hasNotifications = true;
                    this.pdClass = "pd"
                }
            }
        }
    },
    data() {
        return {
            pdClass: "",
            hasNotifications:false
        }
    }
}
</script>

<style lang="css" scoped>
    @import"./style.css";
</style>
